import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=74aaeb9b&scoped=true"
import script from "./Open.vue?vue&type=script&lang=ts"
export * from "./Open.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aaeb9b",
  null
  
)

export default component.exports